import L from 'leaflet'
import 'leaflet/dist/leaflet.css'

export default {
    install: (app, options) => {
        app.config.globalProperties.$L = L
    }
}
